var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15167 4.28389L13.372 0.127163C13.2091 0.0436174 13.0288 0.000108328 12.8458 0H1.16674C0.983804 0.000108522 0.803477 0.0436174 0.640625 0.127163L5.8609 4.28389C6.18564 4.54461 6.58981 4.68675 7.00634 4.68675C7.42288 4.68675 7.82705 4.54462 8.15178 4.28389H8.15167Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.817 0.529352L9.75781 3.76168L13.8465 7.85063C13.9503 7.67367 14.0051 7.47218 14.0051 7.267V1.16176C14.0052 0.937059 13.9398 0.717343 13.8169 0.529297L13.817 0.529352Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.188248 0.529297C0.0653161 0.717329 -0.000108193 0.937053 1.34306e-07 1.16176V7.267V7.26689C1.34306e-07 7.47206 0.0547944 7.67356 0.158628 7.85052L4.2473 3.76157L0.188248 0.529297Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51476 4.74552C8.08553 5.09 7.55148 5.27782 7.00106 5.27782C6.45065 5.27782 5.91659 5.09001 5.48737 4.74552L4.7143 4.12988L0.578125 8.26605C0.755091 8.36989 0.956466 8.42468 1.16165 8.42468H12.8408C13.0459 8.42468 13.2473 8.36989 13.4243 8.26605L9.28811 4.12988L8.51476 4.74552Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.879a51327c527d2c98e71e61ef5ac114.svg";
export { ForwardRef as ReactComponent };